<div mobile (mobileView)="onMobileView($event)" class="statuory-main" [ngClass]="{'statuory-main--mobile': isMobile}">
  <div class="col-lg-12 row" *ngIf="topicList.length>0" [ngClass]="{'margin-0 padding-0': isMobile}">
    <div class="col-lg-4 tabs-section" [ngClass]="{'padding-0': isMobile}">
      <div *ngFor="let item of topicList;let i=index">
        <div class="question-tabs cursor-pointer" (click)="setActive(i)"
          [ngClass]="{'active-tab-button2':i===activeId}">
          <a class="tab-btn-text2">{{item.subType}}</a>
        </div>
      </div>
      <div class="question-tabs cursor-pointer">
        <a class="tab-btn-text2" [routerLink]="['/executive-remuneration']">Executive Remuneration</a>
      </div>
    </div>
    <div class="col-lg-8 answer-section" [ngClass]="{'padding-0': isMobile}">
      <div class="article-heading2">{{ topicList[activeId].subType}} </div>
      <div class="answwer-content padding-20">
        <div class="col-lg-12 expansion-section padding-0">
          <div class="expansion-panel-data" [ngClass]="{'expansion-panel--collapsed':  item.hide}"
            *ngFor="let item of topicList[activeId].subTypesList;let i=index">
            <div class="question-section">
              <a *ngIf="item.topic !== 'undefined'" (click)="toggleSection(item)" class="cursor-pointer">
                {{item.topic}}
                <span class="expansion-icons">
                  <img src="assets/icons/plus.png" class="cursor-pointer" *ngIf="item.hide">
                  <img src="assets/icons/minus.png" class="cursor-pointer" *ngIf="!item.hide">
                </span>
              </a>
            </div>
            <div class="answer-section" *ngIf="!item.hide">
              <!---FILETR COMPONENT -->
              <app-statutory-filter [subType]="item"></app-statutory-filter>
              <ng-container
                *ngTemplateOutlet="dataDisplayTemplate;context:{'filteredData' : item.topicsList | multiSearchFilter: {year: item.selectedYear, month: item.selectedMonth}}">
              </ng-container>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!---TEMPLATE DATA-->
<ng-template #dataDisplayTemplate let-filteredData="filteredData">
  <ng-template [ngIf]="filteredData?.length > 0">
    <div class="file-list-section" [ngClass]="{'border-btm': !last}"
      *ngFor="let subItem of filteredData; let i=index;let last=last;">
      <div class="file-list-section--name">
        {{subItem.fileName}}
      </div>
      <div class="file-list-section--actions">
        <img src="assets/icons/icon_view.png" class="view-img cursor-pointer" (click)="viewFile(subItem.url)">
        &nbsp;
        <span class="tab-seperator"></span>
        &nbsp;
        <file-download [path]="subItem.url"></file-download>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="filteredData?.length === 0">
    <span class="no-data">No data found for above selected criteria</span>
  </ng-template>
</ng-template>